module.exports = {"sld:ColorMapEntry":[{"color":"#0074ad","label":"< 1.12914","quantity":0.01129},{"color":"#9dc4b5","label":" 1.12914- 1.42927","quantity":0.01429},{"color":"#e6efc3","label":" 1.42927- 1.83701","quantity":0.01837},{"color":"#ffe89e","label":" 1.83701- 2.66232","quantity":0.02662},{"color":"#f5af7f","label":" 2.66232- 4.22425","quantity":0.04224},{"color":"#ed6d32","label":" 4.22425- 20.00037","quantity":0.2}]}


//////////////////
// WEBPACK FOOTER
// ./static/bunSld_cropRisks/fxfl_raster/rice_MME_1981_2016_lcr_90_return_10.json
// module id = vZGf
// module chunks = 171